import { useMemo } from "react";
import HorseRow from "./HorseRow";

function statusStyle(status) {
  switch (status) {
    case "open": return { dot: "bg-[#2f9e44]", label: "OPEN" };
    case "running": return { dot: "bg-[#c92a2a]", label: "RUNNING" };
    case "finished": return { dot: "bg-[#1971c2]", label: "FINISHED" };
    default: return { dot: "bg-[#adb5bd]", label: "UPCOMING" };
  }
}

function fmtLocalTime(iso) {
  try {
    return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false });
  } catch { return ""; }
}

export default function RaceCard({ race, myPick, staged, cutoffPassed, onPick }) {
  const st = statusStyle(race.status);
  const time = useMemo(() => fmtLocalTime(race.scheduled_time), [race.scheduled_time]);
  const locked = cutoffPassed || race.status === "running" || race.status === "finished";

  return (
    <div className="bg-white border border-[#e9ecef] rounded-2xl overflow-hidden shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)]"
         data-testid={`race-card-${race.id}`}>
      <div className="p-4 border-b border-[#e9ecef]">
        <div className="flex items-center gap-2 flex-wrap">
          <span className={`w-2 h-2 rounded-full ${st.dot}`} />
          <span className="text-[9px] font-black uppercase tracking-wider text-[#6c757d]">{st.label}</span>
          <span className="text-[10px] font-bold text-[#6c757d]">R{race.race_number} · {time}</span>
          {race.week_number != null && (
            <span className="text-[9px] font-black uppercase tracking-wider bg-[#1971c2]/10 text-[#1971c2] border border-[#1971c2]/25 rounded-full px-1.5 py-0.5">
              Wk {race.week_number}
            </span>
          )}
          {race.week_number == null && (
            <span className="text-[9px] font-black uppercase tracking-wider bg-[#f8f9fa] text-[#6c757d] border border-[#e9ecef] rounded-full px-1.5 py-0.5">
              Out of season
            </span>
          )}
        </div>
        <div className="font-display font-extrabold text-lg mt-1 leading-tight">
          {race.track} · {race.race_name}
        </div>
        <div className="text-xs text-[#6c757d] mt-0.5">
          {race.distance_m}m · {race.grade} · {race.horses.length} runners
        </div>
      </div>
      <div className="p-3 space-y-2">
        {race.horses.map((h) => (
          <HorseRow
            key={h.horse_number}
            horse={h}
            picked={myPick && myPick.horse_number === h.horse_number}
            staged={staged}
            locked={locked}
            onPick={() => onPick && onPick(race, h)}
            testIdBase={`race-${race.id}`}
          />
        ))}
      </div>
    </div>
  );
}
